import { useMultiStepContext } from '@components/hoc/MultiStepForm/MultiStepFormContext';
import React, {useState, useEffect} from 'react';
import Loader from '@components/hoc/Loader/Loader';
import {
  getToken,
  save,
  switchFormV2,
  toLocalStorage,
} from '@actions/formulary';
import Error from '@components/pages/Error/Error';
import MultiStepInitializer from './Steps/MultiStepInitializer/MultiStepInitializer';
import MultiPage from './Pages/MultiPage/MultiPage';
import IntroPage from './Pages/IntroPage/IntroPage';
import { formConfig } from '@config/formConfig';
import { domains } from '@config/lists';
import { getCookieValueFromHisName } from '@actions/cookie';
import { cleanStorage } from '@actions/formulary';
import { useGTMDispatch } from '@components/hoc/GTM/GTM';
import { getFormVariableToGtmContent } from '@actions/gtm';

import { getCurrentHost } from '@actions/formManipulation';

const MultiStepFormGeneric = () => {
  const introPage = !!global.window?.Config.introPage ?? !!formConfig.introPage;
  const multiPage = !!global.window?.Config.multiPage ?? !!formConfig.multiPage;

  let dataForForm = [];

  const {
    currentStep,
    maxStep,
    config,
    visibleSteps,
    formDataContext,
    trainingId,
    phrases,
    setStep,
    setConfig,
    updateFormData,
  } = useMultiStepContext();
  const sendDataToGTM = useGTMDispatch();

  const [apiError, setApiError] = useState(false);
  const [apiTimeout, setApiTimeout] = useState(false);
  const [apiNoResponse, setApiNoResponse] = useState(false);
  const [saved, setSaved] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [token, setToken] = useState(null);
  const [tokenAcquired, setTokenAcquired] = useState(false);
  const [leadId, setLeadId] = useState(null);
  const [initialized, setInitialized] = useState(false);
  //loadMetaId from localstorage
  const [metaEventId, setMetaEventId] = useState(null);

  const redirectTo = (url) => {
    window.location.replace(url);
    return null;
  };

  const redirectToMultiV2 = () => {
    // Get the current URL
    const currentUrl = new URL(window.location.href);

    // Redirect to the new URL with preserved search parameters
    return (window.location.href = switchFormV2(currentUrl));
  };

  const handleInvalid = (event) => {
    try {
      console.error('form is invalid it will not trigger', event);
      event.preventDefault();
      // Get all the invalid form elements
      const invalidElements = event.target.querySelectorAll(':invalid');

      // Log specific error messages for each invalid element
      invalidElements.forEach((element) => {
        console.error(
          `Validation error in ${element.name || element.id}: ${
            element.validationMessage
          }`
        );
      });
    } catch (error) {
      console.log('error in handleInvalid', error);
    }
  };

  //TODO : Mettre à jour la methode pour envoyer le form sans passer par 3 useEffects.
  useEffect(() => {
    dataForForm = {
      ...formDataContext,
      ...{ iss: getCurrentHost(), aud: 'addLead', metaEventId: metaEventId },
    };

    if (
      dataForForm['idFormationBitrix'] === 'nothing' ||
      (dataForForm['idFormationBitrix'] === 0 && dataForForm['domainId'])
    ) {
      dataForForm['idFormationBitrix'] = domains.find(
        (item) => Number(item.id) === Number(dataForForm['domainId'])
      )?.defaultTrainingId;
    }

    if (getCookieValueFromHisName('gclid') !== '') {
      dataForForm['gclid'] = getCookieValueFromHisName('gclid');
    }

    if (isSubmitting && !tokenAcquired) {
      getToken(JSON.stringify(dataForForm))
        .then((responseToken) => {
          setToken(responseToken);
          setTokenAcquired(true);
        })
        .catch(() => {
          setApiError(true);
          setTokenAcquired(false);
        });
    }
  }, [isSubmitting]);

  useEffect(() => {
    if (leadId && leadId !== localStorage.getItem('lastLeadId')) {
      toLocalStorage({ lastLeadId: leadId });
      document.cookie = `leadId=${leadId}`;
    }
  }, [leadId]);

  useEffect(() => {
    if (tokenAcquired && token) {
      let finishedAt;
      const startedAt = new Date();
      //use site hostname
      dataForForm = {
        ...formDataContext,
        ...{ iss: getCurrentHost(), aud: 'addLead', metaEventId: metaEventId },
      };

      //! Ajout de l'event de Conversion que l'on va ensuite "confirmer" après réception de l'ID bitrix
      //! mais la conversion ne nécessite pas d'ID bitrix pour être lancée

      sendDataToGTM({
        event: 'ConversionTracking',
      });

      // On doit prévoir le cas où l'utilisateur aurait choisir "je souhaite être conseillé"
      // en linkant la formation par défaut à la thématique qu'il avait vraiment choisie"
      if (
        dataForForm['idFormationBitrix'] === 'nothing' ||
        (dataForForm['idFormationBitrix'] === 0 && dataForForm['domainId'])
      ) {
        //! Ajout d'un cas de tracking demandé, est-ce le cas "je souhaite être conseillé"
        sendDataToGTM({
          souhaiteEtreConseille: true,
        });
        dataForForm['idFormationBitrix'] = domains.find(
          (item) => Number(item.id) === Number(dataForForm['domainId'])
        )?.defaultTrainingId;
      }

      if (getCookieValueFromHisName('gclid') !== '') {
        dataForForm['gclid'] = getCookieValueFromHisName('gclid');
      }

      save(JSON.stringify(dataForForm), token)
        .then((response) => {
          if (response) {
            if (response.data.id) {
              //cas API Mock
              sendDataToGTM({ event: 'setLeadId', leadId: response.data.id });
              setLeadId(response.data.id);
              setApiNoResponse(false);
            } else if (response.data['result']) {
              sendDataToGTM({
                event: 'setLeadId',
                leadId: JSON.parse(response.data['result']),
              });
              setLeadId(JSON.parse(response.data['result']));
              setApiNoResponse(false);
            } else {
              setApiNoResponse(true);
            }
            sendDataToGTM({ event: 'conversion' });
            setSaved(true);
            setIsSubmitting(false);
            cleanStorage();
          } else {
            setSaved(false);
            setIsSubmitting(true);
            setApiTimeout(true);
          }

          finishedAt = new Date();
          if (finishedAt - startedAt > 20000) {
            setApiTimeout(true);
          }
        })
        .catch((error) => {
          console.error(error);
          setApiError(true);
          setSaved(false);
          setIsSubmitting(false);
        });
    } else {
      setSaved(false);
    }
  }, [tokenAcquired, token]);

  const handlePrevStep = (event) => {
    if (event) event.preventDefault();
    //Check validation, store locally and then
    if (currentStep === 1) {
      return history.back();
    }
    sendDataToGTM({ event: 'prevStep' });
    setStep(currentStep - 1);
  };

  const handleNextStep = (event) => {

    if (event) event.preventDefault();
    if (currentStep === maxStep) {
      return;
    }
    sendDataToGTM({ event: 'nextStep' });
    setStep(currentStep + 1);
  };
  /**
   * fonction qui gère le choix sur l'intro page
   *
   * ça redirige l'utilisateur vers le multiform avec le bon url
   * @param {Number} currentStep
   */
  const handleIntro = (currentStep) => {
    redirectToMultiV2();
  };

  //
  const handleFormData = (formData) => {
    try {
      //! A chaque modification de valeur dans le formulaire, on va envoyer les informations dans GTM afin d'avoir un tracking sur certains champs
      const objForGtm = {};
      objForGtm[formData?.name] = formData?.value;
      //! A cause des limitations de JS sur l'assignation de propriétés dynamiques à des objets on doit d'abord créer des variables...
      const valueRetrieval = getFormVariableToGtmContent(formData) ?? objForGtm;
      const gtmEvent = { event: `set${formData?.name}`, ...valueRetrieval };
      sendDataToGTM(gtmEvent);
    } catch (error) {
      console.error('erreur pendant gestion du tracking', error, formData);
    }

    updateFormData(formData);
  };

  // Fonction qui sert à vérifier si toutes les infos obligatoires sont présentes
  const checkFullForm = () => {
    return (
      formDataContext.situationPro &&
      formDataContext.email &&
      formDataContext.nom &&
      formDataContext.prenom &&
      formDataContext.numInt
    );
  };

  const handleSubmit = (event) => {
    try {
      if (event) event.preventDefault();

      if (checkFullForm()) {
        setIsSubmitting(true);
      }
      toLocalStorage(formDataContext);
    } catch (error) {
      console.error('error while submitting');
    }
  };

  const displayMulti = () => {
    if (!introPage && multiPage) {
      return (
        <MultiPage
          currentStep={currentStep}
          visibleSteps={visibleSteps}
          maxStep={maxStep}
          handleSubmit={handleSubmit}
          handleInvalid={handleInvalid}
          formDataContext={formDataContext}
          trainingId={formDataContext.idFormationBitrix ?? trainingId}
          phrases={phrases}
          handleNextStep={handleNextStep}
          handleFormData={handleFormData}
          isSubmitting={isSubmitting}
          handlePrevStep={handlePrevStep}
          config={config}
        />
      );
    }
  };

  const displayIntro = () => {
    if (introPage && !multiPage) {
      return (
        <IntroPage
          currentStep={currentStep}
          visibleSteps={visibleSteps}
          maxStep={maxStep}
          handleSubmit={handleSubmit}
          handleInvalid={handleInvalid}
          formDataContext={formDataContext}
          trainingId={trainingId}
          phrases={phrases}
          handleNextStep={handleIntro}
          handleFormData={handleFormData}
          isSubmitting={isSubmitting}
          handlePrevStep={handlePrevStep}
          config={config}
        />
      );
    }
  };

  if (apiError) {
    if (formConfig.redirect?.onError) {
      return redirectTo(formConfig.redirect.onError);
    }
    return <Error />;
  }

  if (!initialized) {
    return (
      <MultiStepInitializer
        initialized={initialized}
        formConfig={config}
        setInitialized={setInitialized}
        setApiError={setApiError}
        setFormConfig={setConfig}
        handleFormData={handleFormData}
        setMetaEventId={setMetaEventId}
      />
    );
  }

  return (
    <Loader
      isSubmitting={isSubmitting}
      saved={saved}
      apiTimeout={apiTimeout}
      apiNoResponse={apiNoResponse}
    >
      {displayIntro()}
      {displayMulti()}
    </Loader>
  );
};

export default MultiStepFormGeneric;
